module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2-2019-desktop.jpg?v=f24a6c60";